import { Grid } from "@mui/material";
import Footer from "components/footer/Footer.component";
import Header from "components/header/Header.component";
import { get, isEmpty } from "lodash";
import React, { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { useAppApi } from "store/api-context";
import { useAppAuth } from "store/auth-context";
import { ROUTES } from "utils/constants/route.constants";
import localStorageUtils, {
  localStorageKeys,
} from "utils/local-utils/localstorage.utils";

const AppWrapper = ({ children }) => {
  const { mainClient } = useAppAuth();

  const {
    fetchOverview,
    state: { overviews },
  } = useAppApi();

  const { pathname } = useLocation();

  const { isDivisionPath, isAuthPath, isHomePage } = useMemo(
    () => ({
      isDivisionPath:
        pathname?.includes("division") || pathname?.includes("overview"),
      isAuthPath: pathname?.includes("auth"),
      isHomePage: pathname === ROUTES.HOME,
    }),
    [pathname]
  );
  useEffect(() => {
    const divisions = localStorageUtils.get(localStorageKeys.divisions);
    const division = localStorageUtils.get(localStorageKeys.division);

    if (!isEmpty(divisions) || !isEmpty(division)) {
      fetchOverview();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{get(mainClient, "name", "")}</title>
        <link
          rel="icon"
          type="image/png"
          href={overviews[0]?.logo?.location}
          sizes="16x16"
        />
      </Helmet>
      {!isAuthPath ? (
        <Grid container>
          <Grid item xs={12}>
            <Header isDivisionPath={isDivisionPath} />
          </Grid>
          <Grid item xs={12}>
            {children}
          </Grid>
          {isHomePage ? null : (
            <Grid item xs={12}>
              <Footer />
            </Grid>
          )}
        </Grid>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default AppWrapper;
